import React from 'react';

const TestPage = () => {
  return (
    <div style={{
      padding: '50px',
      backgroundColor: 'red',
      color: 'white',
      fontSize: '30px',
      textAlign: 'center'
    }}>
      <h1>REACT IS WORKING!</h1>
      <p>Current time: {new Date().toLocaleString()}</p>
      <p>If you can see this, React is rendering properly.</p>
    </div>
  );
};

export default TestPage;